import classNames from "classnames";

const baseColors = {
  default: "#053C7F",
  error: "#F26464",
  success: "#43BE18",
  warning: "#FFB946",
};

const mapColor = (colorString) => {
  if (!colorString) {
    return baseColors.default;
  } else if (baseColors?.[colorString]) {
    return baseColors[colorString];
  } else {
    return colorString;
  }
};

export const CIconButton = ({
  color = "",
  disabled = false,
  onClick = () => {},
  icon,
  className = "",
  style = {},
  shape = "circle", // rounded
  ...props
}) => {
  return (
    <button
      className={classNames(
        "c-icon-button h-10 w-10 relative aspect-square p-[12px] -my-2 !outline-none overflow-hidden",
        "flex items-center justify-center",
        "[&>svg]:absolute [&>svg]:size-7",
        "after:content-[''] after:inset-0 after:bg-current after:opacity-0 hover:after:opacity-15 after:absolute",
        className,
        disabled ? "!text-[#979797]" : "cursor-pointer",
        shape === "circle" ? "rounded-full" : "rounded-xl",
      )}
      disabled={disabled}
      onClick={onClick}
      style={{ color: mapColor(color), ...style }}
      {...props}
    >
      {icon}
    </button>
  );
};
